<mdb-sidenav-layout>
  <mdb-sidenav
    #sidenav="mdbSidenav"
    data-cy="sidenav-settings"
    [width]="400"
    [right]="true"
  >
    <div class="position-relative h-100">
      <header class="d-flex justify-content-between align-items-center p-2 navbar">
        <p class="mb-0 fw-bold text-muted">Settings</p>
        <button type="button" class="btn-transparent" (click)="onClose()" aria-label="Close">
          <i class="fas fa-xmark"></i>
        </button>
      </header>

      <div class="p-2 d-flex flex-column gap-2">
          <div class="settings-card d-flex align-items-center justify-content-between border rounded-2 bg-white p-2">
            <span class="text-muted">
              GPS :
              @if (isLoading.gpsCheck) {
                <span class="spinner-grow spinner-grow-sm ms-1" role="status" aria-hidden="true"></span>
              } @else {
                {{ device.gps.status || 'N/A' }}
              }
            </span>
            <button
              type="button"
              class="btn btn-primary btn-sm"
              [disabled]="isLoading.gpsCheck || !deviceId"
              (click)="gpsCheck.emit()"
            >
              Check GPS
            </button>
          </div>

          <div class="settings-card d-flex align-items-center justify-content-between border rounded-2 bg-white p-2">
            <span class="text-muted">
              Network :
              @if (isLoading.networkCheck) {
                <span class="spinner-grow spinner-grow-sm ms-1" role="status" aria-hidden="true"></span>
              } @else {
                {{ device.network.status || 'N/A' }}
              }
            </span>
            <button
              type="button"
              class="btn btn-primary btn-sm"
              [disabled]="isLoading.networkCheck || !deviceId"
              (click)="networkCheck.emit()"
            >
              Check Network
            </button>
          </div>

          <div class="settings-card d-flex align-items-center justify-content-between border rounded-2 bg-white p-2">
            <span class="text-muted">Device Logs</span>
            <button
              type="button"
              class="btn btn-primary btn-sm"
              [disabled]="isLoading.downloadLogs || !deviceId"
              (click)="downloadLogs.emit()"
            >
              @if (isLoading.downloadLogs) {
                <span class="spinner-grow spinner-grow-sm me-1" role="status" aria-hidden="true"></span>
              }
              Download Device Logs
            </button>
          </div>

          <div class="settings-card d-flex align-items-center justify-content-between border rounded-2 bg-white p-2">
            <span class="text-muted">RRMS Logs</span>
            <button
              type="button"
              class="btn btn-primary btn-sm"
              [disabled]="isLoading.downloadRrmsLogs"
              (click)="downloadRrmsLogs.emit()"
            >
              @if (isLoading.downloadRrmsLogs) {
                <span class="spinner-grow spinner-grow-sm me-1" role="status" aria-hidden="true"></span>
              }
              Download RRMS Logs
            </button>
          </div>

          @if (canBeginTest) {
            <div class="settings-card border rounded-2 bg-white p-2">
              @if (testEndTime) {
                <div class="d-flex align-items-center justify-content-between">
                  <span class="text-muted small">
                    Test ends at <b>{{ testEndTime }}</b>
                    <span class="ms-2 fw-semibold">{{ displayMinutes }}:{{ displaySeconds }}</span>
                  </span>
                  <button
                    type="button"
                    class="btn btn-primary btn-sm"
                    [disabled]="isLoading.testAction"
                    (click)="stopTest.emit()"
                  >
                    @if (isLoading.testAction) {
                      <span class="spinner-grow spinner-grow-sm me-1" role="status" aria-hidden="true"></span>
                    }
                    Stop Test
                  </button>
                </div>
              } @else {
                <div class="d-flex align-items-center justify-content-between">
                  <span class="text-muted">RRMS Test</span>
                  <button
                    type="button"
                    class="btn btn-primary btn-sm"
                    [disabled]="isLoading.testAction"
                    (click)="beginTest.emit()"
                  >
                    @if (isLoading.testAction) {
                      <span class="spinner-grow spinner-grow-sm me-1" role="status" aria-hidden="true"></span>
                    }
                    Begin Test
                  </button>
                </div>
              }
            </div>
          }

          <div class="settings-card d-flex align-items-center justify-content-between border rounded-2 bg-white p-2">
            <span class="text-muted">Configuration</span>
            <button
              type="button"
              class="btn btn-primary btn-sm"
              [disabled]="!deviceId"
              (click)="editConfiguration.emit()"
            >
              Edit Configuration
            </button>
          </div>
      </div>
    </div>
  </mdb-sidenav>
  <mdb-sidenav-content #sidenavContent></mdb-sidenav-content>
</mdb-sidenav-layout>
